import { render } from "./WiseError.vue?vue&type=template&id=bd9f7856"
import script from "./WiseError.vue?vue&type=script&lang=js"
export * from "./WiseError.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__